export var isSelectedMonth = function (month, selectedDate) {
    if (Array.isArray(selectedDate)) {
        if (!selectedDate[0] || !selectedDate[1])
            return false;
        return (month >= new Date(selectedDate[0].getFullYear(), selectedDate[0].getMonth(), 1) &&
            month <= new Date(selectedDate[1].getFullYear(), selectedDate[1].getMonth(), 1));
    }
    return month.getMonth() === selectedDate.getMonth() && month.getFullYear() === selectedDate.getFullYear();
};
// Hàm kiểm tra xem tháng hiện tại có phải là tháng bắt đầu không
export var isStartMonth = function (month, selectedDate) {
    if (!selectedDate[0] || !selectedDate[1])
        return false;
    return month.getMonth() === selectedDate[0].getMonth() && month.getFullYear() === selectedDate[0].getFullYear();
};
// Hàm kiểm tra xem tháng hiện tại có phải là tháng kết thúc không
export var isEndMonth = function (month, selectedDate) {
    if (!selectedDate[0] || !selectedDate[1])
        return false;
    return month.getMonth() === selectedDate[1].getMonth() && month.getFullYear() === selectedDate[1].getFullYear();
};
